<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-flex">
      <dark-Toggler class="d-none d-md-block" />

    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        v-if="currentPeriod"
        toggle-class="d-flex align-items-center dropdown-user-link"
      >
        <template
          #button-content
        >
          <div class="d-flex flex-row user-nav">
            <feather-icon
              icon="RepeatIcon"
              class="mr-1"
              size="19"
            />
          </div>
        </template>

        <b-dropdown-text>
          <div v-if="currentPeriod">
            <p class="m-0">
              Saldo actual:
            </p>
            <b>{{ currentPeriod.getAttr('cash_fund') }}</b>
          </div>
        </b-dropdown-text>
        <b-dropdown-divider />
        <!--        <b-dropdown-item>
          Nuevo movimiento
        </b-dropdown-item>
        <b-dropdown-divider />
        <b-dropdown-item>
          Nuevo depósito
        </b-dropdown-item>
        <b-dropdown-item>
          Nuevo retiro
        </b-dropdown-item>
        <b-dropdown-divider />-->

        <b-dropdown-item>
          <router-link to="/loan-request">
            Nueva solicitud de crédito
          </router-link>
        </b-dropdown-item>

      </b-nav-item-dropdown>

      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template
          v-if="user"
          #button-content
        >
          <div class="d-flex flex-row user-nav">
            <feather-icon
              icon="UserIcon"
              class="mr-1"
            />
            <span class="user-status">{{ user.first_name }} {{ user.last_name }}</span>
          </div>
        </template>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Cerrar sesión</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownText, BDropdownDivider,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import { getUserData } from '@/auth/utils'
import useJwt from '@/auth/jwt/useJwt'
import { initialAbility } from '@/libs/acl/config'
import store from '@/store'
import { computed, ref } from '@vue/composition-api'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    // Navbar Components
    DarkToggler,
    BDropdownText,
    BDropdownDivider,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    logout() {
      // Remove userData from localStorage
      // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

      // Remove userData from localStorage
      localStorage.removeItem('userData')

      // Reset ability
      this.$ability.update(initialAbility)

      // Redirect to login page
      this.$router.push({ name: 'auth-login' })
    },
  },
  setup() {
    const user = getUserData()
    const needLoadPeriod = ref(false)
    if (user.type.toString() !== '1') {
      store.dispatch('app/loadCurrentPeriod')
      needLoadPeriod.value = true
    }

    return {
      user,
      currentPeriod: computed(() => store.state.app.currentPeriod),
      needLoadPeriod,
    }
  },
}
</script>
